import { Component, Vue } from "vue-property-decorator";

import WithRender from "./SendersDurationDetails.html";

import { Inject } from "vue-di-container";

import RequestsSendersService from "../RequestsSendersService";

import { Toaster } from "@/Services/toast";

import { SendersDetailsFilterModel } from "../SendersDetailsFilterModel";

import {

    assignSendersDurationRowKeys,

    buildSendersDurationScopePayload,

    downloadExcelFromBase64,

    EMPTY_GUID,

    formatCreatedDate,

    formatSenderNameDuration,

    getTodayStr,

    loadSendersFilterFromStorage,

} from "../sendersDetailsShared";



@WithRender

@Component({

    diProvide: [RequestsSendersService],

})

export default class SendersDurationDetails extends Vue {

    @Inject(RequestsSendersService)

    public requestsSendersService!: RequestsSendersService;



    public isLoading: boolean = false;

    public rows: any[] = [];

    public totalCount: number = 0;

    public clientItems: string[] = [];

    public senderNameFilter: string = "";

    public clientNameFilter: string = "";

    public senderNameDurationFilter: number | null = null;

    public senderNameDurationItems: { text: string; value: number | null }[] = [];



    public pagination: any = {

        page: 1,

        rowsPerPage: 10,

        sortBy: "createdDate",

        descending: true,

    };

    public isSorted: boolean = true;

    public headers: any[] = [];



    private sendersFilter: SendersDetailsFilterModel = {

        dateFrom: "2022-02-01",

        dateTo: "",

        tenantId: EMPTY_GUID,

        providerId: EMPTY_GUID,

        customerType: 0,

        activeNow: false,

    };



    private chartDurationBucket: number | null = null;

    private searchDebounceId: any = null;



    public clientNameMenuProps: Record<string, unknown> = {

        contentClass: "monitor-dashboard-select-menu all-requests-details-client-menu",

        offsetY: true,

        maxHeight: 260,

    };



    public created(): void {

        this.initHeaders();

        this.initSenderNameDurationItems();

        loadSendersFilterFromStorage(this.sendersFilter);

        this.applyRouteDurationDrillDown();

    }



    public async mounted(): Promise<void> {

        if (!this.sendersFilter.dateTo) {

            this.sendersFilter.dateTo = getTodayStr();

        }

        await this.loadClients();

        await this.loadTable();

    }



    public initSenderNameDurationItems(): void {

        this.senderNameDurationItems = [

            { text: "1 " + this.$t("shared.year").toString(), value: 1 },

            { text: "2 " + this.$t("monitorDashboard.years").toString(), value: 2 },

            { text: "3 " + this.$t("monitorDashboard.years").toString(), value: 3 },

            { text: "4 " + this.$t("monitorDashboard.years").toString(), value: 4 },

            { text: "5+ " + this.$t("monitorDashboard.years").toString(), value: 5 },

        ];

    }



    public initHeaders(): void {

        this.headers = [

            {

                text: this.$t("monitorDashboard.requestId"),

                value: "requestId",

                align: "center",

                sortable: false,

            },

            {

                text: this.$t("monitorDashboard.createdDate"),

                value: "createdDate",

                align: "center",

                sortable: true,

                width: "160",

            },

            {

                text: this.$t("monitorDashboard.customerType"),

                value: "customerType",

                align: "center",

                sortable: false,

            },

            {

                text: this.$t("monitorDashboard.senderName"),

                value: "senderName",

                align: "center",

                sortable: false,

            },

            {

                text: this.$t("monitorDashboard.clientName"),

                value: "clientName",

                align: "center",

                sortable: false,

            },

            {

                text: this.$t("monitorDashboard.senderNameDuration"),

                value: "senderNameDuration",

                align: "center",

                sortable: false,

            },

            {

                text: this.$t("monitorDashboard.smsServiceProvider"),

                value: "smsServiceProvider",

                align: "center",

                sortable: false,

            },

            {

                text: this.$t("monitorDashboard.serviceProvider"),

                value: "serviceProvider",

                align: "center",

                sortable: false,

            },

        ];

    }



    private applyRouteDurationDrillDown(): void {

        const q = this.$route.query;

        if (!q) {

            return;

        }



        const durationRaw = q.duration != null ? String(q.duration) : "";

        const duration = durationRaw ? Number(durationRaw) : NaN;



        if (!isNaN(duration) && duration >= 1 && duration <= 5) {

            this.chartDurationBucket = duration;

            this.senderNameDurationFilter = duration;

        }

    }



    private buildScopePayload(): any {

        return buildSendersDurationScopePayload(

            this.sendersFilter,

            this.chartDurationBucket,

        );

    }



    private resolveDurationFilter(): number | null {

        if (this.senderNameDurationFilter != null) {

            return this.senderNameDurationFilter;

        }

        return this.chartDurationBucket;

    }



    private buildDetailsPayload(): any {

        const payload: any = this.buildScopePayload();

        payload.senderName = this.senderNameFilter ? this.senderNameFilter.trim() : "";

        payload.clientName = this.clientNameFilter ? this.clientNameFilter.trim() : "";

        payload.pageIndex = (this.pagination.page - 1) >= 0 ? this.pagination.page - 1 : 0;

        payload.pageSize = this.pagination.rowsPerPage || 10;

        payload.sortBy = "CreatedDate";

        payload.sortDirection = this.pagination.descending === true;



        const durationFilter = this.resolveDurationFilter();

        if (durationFilter != null) {

            payload.senderNameDuration = durationFilter;

        }



        return payload;

    }



    public async loadClients(): Promise<void> {

        const resp = await this.requestsSendersService.GetSendersDurationDetailsClients(

            this.buildScopePayload(),

        );

        if (!resp || !resp.isSuccess || !resp.result) {

            this.clientItems = [];

            return;

        }

        this.clientItems = resp.result;

    }



    public async loadTable(): Promise<void> {

        this.isLoading = true;

        const resp = await this.requestsSendersService.GetSendersDurationDetails(

            this.buildDetailsPayload(),

        );

        this.isLoading = false;



        if (!resp || !resp.isSuccess) {

            if (resp && resp.errorMessage) {

                Toaster.error(resp.errorMessage);

            }

            this.rows = [];

            this.totalCount = 0;

            return;

        }



        this.rows = assignSendersDurationRowKeys(resp.result || []);

        this.totalCount = resp.totalCount != null ? Number(resp.totalCount) : 0;

    }



    public onSenderNameInput(): void {

        if (this.searchDebounceId) {

            clearTimeout(this.searchDebounceId);

        }

        const self = this;

        this.searchDebounceId = setTimeout(function () {

            self.pagination.page = 1;

            self.loadTable();

        }, 800);

    }



    public onClientNameChange(): void {

        if (this.searchDebounceId) {

            clearTimeout(this.searchDebounceId);

            this.searchDebounceId = null;

        }

        this.pagination.page = 1;

        this.loadTable();

    }



    public onClientNameKeyup(): void {

        if (this.searchDebounceId) {

            clearTimeout(this.searchDebounceId);

        }

        const self = this;

        this.searchDebounceId = setTimeout(function () {

            self.pagination.page = 1;

            self.loadTable();

        }, 800);

    }



    public onSenderNameDurationChange(): void {

        this.pagination.page = 1;

        this.loadTable();

    }



    public async resetLocalFilters(): Promise<void> {

        this.senderNameFilter = "";

        this.clientNameFilter = "";

        this.senderNameDurationFilter = null;

        this.pagination.page = 1;

        await this.loadTable();

    }



    public async onExport(): Promise<void> {

        const data = await this.requestsSendersService.ExportSendersDurationDetails(

            this.buildDetailsPayload(),

        );

        if (!data || !data.isSuccess || !data.result) {

            if (data && data.errorMessage) {

                Toaster.error(data.errorMessage);

            }

            return;

        }

        downloadExcelFromBase64(data.result, "SendersDurationDetails.xlsx");

    }



    public goBack(): void {

        this.$router.push({

            name: "MonitorDashboard",

            query: {

                topTab: "0",

                requestsTab: "1",

            },

        });

    }



    public changeSort(column: string): void {

        if (column !== "createdDate") {

            return;

        }

        if (this.pagination.sortBy === column) {

            this.pagination.descending = !this.pagination.descending;

        } else {

            this.pagination.sortBy = column;

            this.pagination.descending = true;

        }

        this.isSorted = true;

        this.loadTable();

    }



    public async updatePaginate(val: any): Promise<void> {

        this.pagination.page = val.page;

        this.pagination.rowsPerPage = val.rowsPerPage;

        await this.loadTable();

    }



    public formatCreatedDate(value: string): string {

        return formatCreatedDate(value);

    }



    public formatSenderNameDuration(value: number): string {

        return formatSenderNameDuration(

            value,

            this.$t("shared.year").toString(),

            this.$t("monitorDashboard.years").toString(),

        );

    }

}


